import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { GetProductListViewModelSuccessEnvelop } from '@/types/api'

import { PRODUCT_QUERY_PARAMS } from '@/features/navigation/constants'

import { useUserToken } from '@/features/user-token-provider/use-user-token'

import { getPageNumberFromSearchParams } from '@/components/header/search/utils/search-helpers'

import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines'
import { QueryKeys } from '@/app/_utils/react-query'

import { getProductsList } from './get-products-list'

import { FIRST_LOAD_PAGE_SIZE } from '../constants'
import { usePLPFacetsContext } from '../facets-context/facets-context'

export default function usePLPData() {
    const { searchParams } = usePLPFacetsContext()

    const searchParamsPageNumber = getPageNumberFromSearchParams(searchParams)
    const { userToken } = useUserToken()

    const requestParams = { ...searchParams }

    const isReady = !!searchParams

    if (isReady && !searchParamsPageNumber && !PUBLIC_IS_BOT) {
        requestParams[PRODUCT_QUERY_PARAMS.PAGE_SIZE] = `${FIRST_LOAD_PAGE_SIZE}`
    }

    if (isReady && !PUBLIC_IS_BOT) {
        requestParams.ut = userToken
    }

    const { data, isFetching, isPending } = useQuery<GetProductListViewModelSuccessEnvelop>({
        queryKey: QueryKeys.PLP.PagesData(requestParams),
        queryFn: () => getProductsList(requestParams),
        refetchOnMount: false,
        staleTime: Infinity,
        placeholderData: keepPreviousData,
        enabled: isReady,
    })

    const products = data?.data?.products?.items || []

    return {
        pageResponse: data?.data,
        products,
        isLoading: isFetching,
        searchParamsPageNumber,
        isLoadingFirstPage: isFetching && (!products || !products.length),
        isPending,
    }
}
